<template>
  <div>
    <div giveMeATour-v-step="10" gt_ParamOrbitTransfert1-v-step="22"></div>
    <div gt_ParamOrbitTransfert1-v-step="23"></div>
    <div gt_ParamOrbitTransfert1-v-step="27"></div>
    <exo-table :root="_self" :formWidth="1300">
      <exo-form :root="_self">
        <v-row no-gutters>
          <v-col cols="6" class="form-column">
            <exo-input-name
              alignWithParametricField
              :root="_self"
              gt_ParamOrbitTransfert1-v-step="24"
            />
            <div gt_ParamOrbitTransfert1-v-step="28"></div>
            <exo-input-parametric
              :root="_self"
              name="altitude"
              tooltip="The parametric studies handles circular orbits only"
              gt_ParamOrbitTransfert1-v-step="25"
            />
            <exo-input-checkbox
              alignWithParametricField
              :root="_self"
              name="sunSynchronousOrbit"
            >
              <exo-help-dialog margin="mb-6" title="Sun-synchronous orbit">
                Sun-synchronous orbits are orbits for which the local time at
                the ascending node is constant. In other words, the spacecraft
                following such an orbit will always cross the Equator with the
                same illumination conditions with respect to the Sun. This can
                be particularly interesting for observation satellites, or for
                having constant illumination conditions on the solar panels.
                <br />
                <br />
                In the parametric studies, only the perturbation effects of the
                <katex-element expression="J_2" />
                harmonic of Earth's potential are taken into account to design
                circular Sun-synchronous orbits.
                <br />
                <br />
                If you choose to operate a spacecraft on a circular
                Sun-synchronous orbit, the inclination of the orbit will be
                computed from its altitude. If you uncheck the box, you will be
                able to choose any altitude and inclination for the orbit.
              </exo-help-dialog>
            </exo-input-checkbox>
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="inputs.sunSynchronousOrbit && isNotValidSSOAltitude"
            >
              Error: the altitude is too high. No sun-synchronous inclination
              exists at this altitude
            </exo-form-alert>
            <exo-input-parametric
              v-if="!inputs.sunSynchronousOrbit"
              :root="_self"
              name="inclination"
            />
          </v-col>
          <v-col cols="6">
            <cesium-viewer
              :tracesResults="this.tracesResults"
              :loading="isCesiumLoading"
            />
          </v-col>
        </v-row>
        <div gt_ParamOrbitTransfert1-v-step="26"></div>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="modalRef" />
    <v-tour
      name="orbitTour"
      :steps="steps"
      :callbacks="customTourCallbacks"
    ></v-tour>
    <v-tour
      name="paramOrbitalTransfer1TourAnaOrbit"
      :steps="steps_analytical_orbit"
      :callbacks="customOrbitCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import { mapGetters } from 'vuex'
import guidedTutorialParamOrbitalTransfer1 from '../../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import { steps_analytical_orbit } from '../../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import analyticalMixin from '../../mixins/analyticalFoms.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import dataTools from '../../tools/data.js'
import loadPlotComponents from '../../components/Plot/plotComponents.js'
import AnalyticalOrbitViewer from './AnalyticalOrbitViewer.vue'
import debounce from 'debounce'

loadPlotComponents()

export default {
  name: 'analyticalorbit',

  mixins: [formMixin, analyticalMixin],
  components: {
    'cesium-viewer': AnalyticalOrbitViewer
  },

  data() {
    const self = this
    return {
      tracesResults: {},
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'type', text: 'Type', sortable: true },
        {
          value: 'sunSynchronousOrbit',
          text: 'Sun-synchronous',
          sortable: true
        },
        {
          value: 'altitude',
          text: 'Altitude' + this.getDefaultUnitLabel('altitude'),
          sortable: true
        },
        {
          value: 'inclination',
          text: 'Inclination' + this.getDefaultUnitLabel('inclination'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      enumPropertiesList: this.getEnumProperties(),

      modalRef: { content: {} },
      showModal: false,
      errorTrace: '',
      steps_analytical_orbit: steps_analytical_orbit,
      inputs: {
        visualizationDate: this.getDefaultValue('visualizationDate'),
        type: 'Circular', // elliptical no more managed because analytical manoeuvres can not change eccentricity
        altitude: this.getDefaultValue('altitude'),
        inclination: this.getDefaultValue('inclination'),
        sunSynchronousOrbit: this.getDefaultValue('sunSynchronousOrbit'),
        parametricValues: {
          altitude: this.buildDefaultParametricValue('altitude'),
          inclination: this.buildDefaultParametricValue('inclination')
        }
      },
      steps: [
        {
          target: '[giveMeATour-v-step="10"]',
          content: `The table shows you all the <strong>objects you have already created</strong>. In some cases, "by default" objects already exist.
            You can create new objects by clicking on the "new" button.`
        }
      ],
      customTourCallbacks: {
        onFinish: () => {
          self.$router.push('/analyticalmission')
        },
        onSkip: () => {
          self.$router.push('/analyticalmission')
        }
      },
      customOrbitCallbacks: {
        onNextStep: (currentStep) => {
          guidedTutorialParamOrbitalTransfer1.onNextStepAnaOrbit(
            currentStep,
            this
          )
        },
        onSkip: () => {
          this.gt_OrbitTransferParam1.orbitsTourDone = true
        },
        onFinish: () => {
          guidedTutorialParamOrbitalTransfer1.onFinishAnaOrbit(this)
        }
      },
      isCesiumLoading: false
    }
  },

  mounted() {
    if (this.giveMeATour) {
      this.$tours['orbitTour'].start()
    }
    if (this.gt_OrbitTransferParam1.isActive) {
      this.$tours['paramOrbitalTransfer1TourAnaOrbit'].start()
    }
  },

  computed: {
    ...mapGetters(['giveMeATour', 'gt_OrbitTransferParam1']),
    traceBuilderWatcher() {
      return [
        this.inputs.type,
        this.inputs.altitude,
        this.inputs.inclination,
        this.inputs.sunSynchronousOrbit,
        this.inputs.visualizationDate,
        this.inputs.parametricValues.altitude.active,
        this.inputs.parametricValues.inclination.active
      ]
    },

    isNotValidSSOAltitude() {
      let earthJ2 = 0.00108262668355315
      let earthRadius = 6378.1363
      let earthMu = 3.986004415e14
      let earthRotationRate = 1.99099300639395e-7
      let K =
        (-3.0 * earthJ2 * Math.pow(earthRadius * 1e3, 2) * Math.sqrt(earthMu)) /
        (2.0 * earthRotationRate)
      let semiMajorAxis = earthRadius + Number(this.inputs.altitude)
      let maxSMA = Math.pow(-K, 2.0 / 7.0)
      if (semiMajorAxis * 1e3 > maxSMA) {
        return true
      } else {
        return false
      }
    }
  },

  created() {
    this.computeEphemerisTraces = debounce(this.computeEphemerisTraces, 1e3)
  },

  watch: {
    inputs: {
      handler() {
        if (this.paramsValid) {
          this.computeEphemerisTraces()
        }
      },
      deep: true
    }
  },

  methods: {
    async computeEphemerisTraces() {
      this.isCesiumLoading = true
      if (
        !this.inputs.parametricValues.altitude.active &&
        !this.inputs.parametricValues.inclination.active
      ) {
        this.tracesResults = [
          [
            await this.computeTraceForSingleAltitude(
              parseFloat(this.inputs.altitude) * 1e3,
              dataTools.deg2rad(parseFloat(this.inputs.inclination))
            )
          ]
        ]
      } else {
        const paramAltitude = this.inputs.parametricValues.altitude
        const paramInclination = this.inputs.parametricValues.inclination
        let inclination = dataTools.deg2rad(parseFloat(this.inputs.inclination))
        if (!this.inputs.parametricValues.inclination.active) {
          await this.computeTraces(paramAltitude, inclination).then(
            (tracesData) => {
              this.tracesResults = [tracesData]
            }
          )
        } else {
          let inclinations = []
          let tracesData = []
          switch (paramInclination.rangeType) {
            case 'Number':
              inclinations =
                this.computeInclinationsFromNumber(paramInclination)
              for (let i = 0; i < inclinations.length; i++) {
                const inclination = inclinations[i]
                if (paramAltitude.active) {
                  tracesData.push(
                    await this.computeTraces(paramAltitude, inclination)
                  )
                } else {
                  tracesData.push([
                    await this.computeTraceForSingleAltitude(
                      parseFloat(this.inputs.altitude) * 1e3,
                      inclination
                    )
                  ])
                }
              }
              break
            case 'Step':
              inclinations = this.computeInclinationsFromStep(paramInclination)
              for (let i = 0; i < inclinations.length; i++) {
                const inclination = inclinations[i]
                if (paramAltitude.active) {
                  tracesData.push(
                    await this.computeTraces(paramAltitude, inclination)
                  )
                } else {
                  tracesData.push([
                    await this.computeTraceForSingleAltitude(
                      parseFloat(this.inputs.altitude) * 1e3,
                      inclination
                    )
                  ])
                }
              }
              break
            case 'Values':
              inclinations = paramInclination.values.map((val) =>
                dataTools.deg2rad(parseFloat(val))
              )
              for (let i = 0; i < inclinations.length; i++) {
                const inclination = inclinations[i]
                if (paramAltitude.active) {
                  tracesData.push(
                    await this.computeTraces(paramAltitude, inclination)
                  )
                } else {
                  tracesData.push([
                    await this.computeTraceForSingleAltitude(
                      parseFloat(this.inputs.altitude) * 1e3,
                      inclination
                    )
                  ])
                }
              }
              break

            default:
              break
          }
          this.tracesResults = tracesData
        }
      }
      this.isCesiumLoading = false
    },

    async computeTraceForSingleAltitude(altitude, inclination) {
      let formObject = this.createObjectFromForm()
      formObject.altitude = altitude
      formObject.inclination = inclination
      const data = await this.$http
        .post('/physics/analyticalorbittraces', formObject)
        .then(function (response) {
          return {
            traces: response.data,
            altitude: altitude,
            inclination: inclination
          }
        })
        .catch((e, response) => {
          this.errorTrace = this.getErrorMessage(e)
          return null
        })

      if (data == null) {
        this.tracesResults = null
      } else {
        this.errorTrace = ''
        return {
          altitude: data.altitude,
          inclination: data.inclination,
          traces: [data.traces]
        }
      }
    },

    async computeTraces(paramAltitude, inclination) {
      switch (paramAltitude.rangeType) {
        case 'Number':
          return await this.computeTracesFromNumber(paramAltitude, inclination)
        case 'Step':
          return await this.computeTracesFromStep(paramAltitude, inclination)
        case 'Values':
          return await this.computeTracesFromValues(paramAltitude, inclination)
        default:
          break
      }
    },

    computeInclinationsFromNumber(paramInclination) {
      let inclinations = []
      const step =
        (parseFloat(paramInclination.max) - parseFloat(paramInclination.min)) /
        parseInt(paramInclination.rangeNumber)
      for (let i = 0; i <= parseInt(paramInclination.rangeNumber); i++) {
        inclinations.push(
          dataTools.deg2rad(parseFloat(paramInclination.min) + step * i)
        )
      }
      return inclinations
    },

    computeInclinationsFromStep(paramInclination) {
      let inclinations = []
      const step = parseFloat(paramInclination.rangeStep)
      let currentInclination = 0
      let i = 0
      do {
        currentInclination = parseFloat(paramInclination.min) + step * i
        i++
        inclinations.push(dataTools.deg2rad(currentInclination))
      } while (currentInclination < parseFloat(paramInclination.max))
      return inclinations
    },

    async computeTracesFromNumber(paramAltitude, inclination) {
      let tracesData = []
      const step =
        (parseFloat(paramAltitude.max) - parseFloat(paramAltitude.min)) /
        parseFloat(paramAltitude.rangeNumber)
      let currentAltitude = 250e3
      for (let i = 0; i <= parseFloat(paramAltitude.rangeNumber); i++) {
        currentAltitude = parseFloat(paramAltitude.min) + step * i
        tracesData.push(
          await this.computeTraceForSingleAltitude(
            currentAltitude * 1e3,
            inclination
          )
        )
      }
      return tracesData
    },

    async computeTracesFromStep(paramAltitude, inclination) {
      let tracesData = []
      const step = parseFloat(paramAltitude.rangeStep)
      let currentAltitude = 250e3
      let i = 0
      do {
        currentAltitude = parseFloat(paramAltitude.min) + step * i
        i++
        tracesData.push(
          await this.computeTraceForSingleAltitude(
            currentAltitude * 1e3,
            inclination
          )
        )
      } while (currentAltitude < paramAltitude.max)
      return tracesData
    },

    async computeTracesFromValues(paramAltitude, inclination) {
      let tracesData = []
      for (let i = 0; i < paramAltitude.values.length; i++) {
        const currentAltitude = parseFloat(paramAltitude.values[i])
        tracesData.push(
          await this.computeTraceForSingleAltitude(
            currentAltitude * 1e3,
            inclination
          )
        )
      }
      return tracesData
    },

    getRequiredPropertiesList(instance) {
      let orbitType = this.getOrbitType(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        orbitType,
        'required'
      )
      if (!instance.sunSynchronousOrbit) {
        requiredList.push('inclination')
      }
      return requiredList
    },

    getOptionalPropertiesList(instance) {
      let orbitType = this.getOrbitType(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        orbitType,
        'optional'
      )
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      optionalList.push('inclination') // to display in the table
      return [...new Set(requiredList.concat(optionalList))]
    },

    getOrbitType(instance) {
      let types = { type: instance.type }
      if (instance.type === 'Elliptical') {
        types.definitionType = instance.definitionType
      }
      return types
    },

    getCurrentFormType() {
      return 'ParametricOrbitDefinition'
    },

    getRefList(param) {
      return []
    }
  }
}
</script>
